import request from 'ca-request';

// DEPRECATED
// This module allows us to ensure that all enqueued ajax requests run sequentially,
// but a more reliable, more performant approach would be to orchestrate their
// sequence explicitly using Promises. Where possible you should do that instead.

const $queue = $({});

// enqueue a function returning a Promise of a request
function enqueue(makeRequest) {
  $queue.queue((next) => makeRequest().then(next, next));
}

// enqueue a jQuery.ajax request
export default function ajaxQueue(ajaxOpts) {
  enqueue(() => request.wrapJQueryRequest($.ajax(ajaxOpts)));
}

// expose ajaxQueue on jQuery global
$.ajaxQueue = ajaxQueue;
